import React from 'react';
import { UserIcon } from '@twilio-paste/icons/cjs/UserIcon';
import { UserInfoWithTruncation } from './UserInfoWithTruncation';
import {
  UserDialogContainer,
  UserDialog,
  UserDialogUserInfo,
  UserDialogList,
  UserDialogListItem,
  UserDialogSeparator,
  useUserDialogListState,
} from '@twilio-paste/core/user-dialog';
import { LogOutIcon } from '@twilio-paste/icons/esm/LogOutIcon';
import { content } from '../content';
import { useMenuState } from '@twilio-paste/core/menu';

export type UserSettingsProps = {
  name: string;
  email: string;
  userSettingsUrl: string;
  logoutRoute: string;
};

export const UserSettings: React.FC<UserSettingsProps> = ({
  name,
  email,
  userSettingsUrl,
  logoutRoute,
}) => {
  const menu = useMenuState();
  const userDialogList = useUserDialogListState(menu);

  return (
    <UserDialogContainer
      {...menu}
      name={'User settings options'}
      icon={UserIcon}
      baseId={'user-settings'}
    >
      <UserDialog aria-label={'User settings'}>
        <UserDialogUserInfo>
          <UserInfoWithTruncation email={email} fullName={name} />
        </UserDialogUserInfo>
        <UserDialogList {...userDialogList} aria-label="User menu actions">
          {/* User settings */}
          <UserDialogListItem {...userDialogList} href={userSettingsUrl}>
            {content.userSettings}
          </UserDialogListItem>
          <UserDialogSeparator />
          {/* Logout */}
          <UserDialogListItem
            {...userDialogList}
            tabIndex={-1}
            href={logoutRoute}
          >
            <LogOutIcon decorative={true} size="sizeIcon30" />
            {content.logout}
          </UserDialogListItem>
        </UserDialogList>
      </UserDialog>
    </UserDialogContainer>
  );
};
